/* eslint-disable array-callback-return */
import React from "react";
import './UserLabelsComponent.scss';
import {UserService} from "../../services/UserService";
import {getContainer} from "../../ioc/IOCSetup";
import { WithContext as ReactTags } from "react-tag-input";
import { UserLabel } from "../../http/protocol";
import { ConfirmModal } from "../../util/ConfirmModal";

type Tag = {
    id:string,
    text:string,
}

interface Props {
    userLabels: string[];
    userId:number;
}

interface State {
    tags: Tag[];
    suggestions: Tag[];
    showIdleForm: boolean,
    numberTag?: number
    textTag?: string
}

const KeyCodes = {
    comma: 188,
    enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

export class UserLabelsComponent extends React.Component<Props, State> {
    userService:UserService;
    constructor(props:Props) {
        super(props);

        this.userService = getContainer().getUserService();
        this.state = {
            tags: [],
            suggestions: [],
            showIdleForm: false,
            numberTag: undefined,
            textTag: undefined
        };
    }

    componentDidMount() {
        //Get all labels:
        this.userService.getAllLabels().then((e) => {
            let suggestionObject:Tag[] = []
            if(e.length > 0) {
                e.map((label:UserLabel) => {
                    suggestionObject.push({id : ""+label.id || "", text : label.value || ""});
                })
            }
            this.setState({suggestions:suggestionObject})
        })

    }

    componentDidUpdate(prevProps:Props) {
        if(this.props.userLabels !== prevProps.userLabels) {
            if(this.props.userLabels === undefined || this.props.userLabels.length === 0) {
                this.setState({tags:[]})
            } else {
                let ul:Tag[] = this.props.userLabels.map((label) => {
                    return {id:label, text:label};
                })
                this.setState({tags:ul})
            }
        }
    }

    async handleDelete(i:number) {
        console.log("DELETE!")
        const { tags } = this.state;
        if(this.state.tags.length > 0) {
            let labelToDelete = this.state.tags[i].id;
            await this.userService.deleteUserLabel(this.props.userId, labelToDelete).then(()=> {
                this.setState({
                    tags: tags.filter((tag, index) => index !== i),
                });
            })
        }
        this.setState({showIdleForm:false})
    }

    async handleAddition(tag:Tag) {
        await this.userService.addUserLabel(this.props.userId, tag.id).then(() => {
            this.setState(state => ({ tags: [...state.tags, tag] }));

        });
    }

    handleDrag(tag:Tag, currPos:number, newPos:number) {
        const tags = [...this.state.tags];
        const newTags = tags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        this.setState({ tags: newTags });
    }

    render() {
        const { tags, suggestions } = this.state;
        console.log(tags);
        return (
            <div id="tagMaker">
                <ReactTags tags={tags}
                           suggestions={suggestions}
                           handleDelete={(e:number) => this.setState({
                                showIdleForm: true,
                                numberTag: e,
                                textTag: tags[e].text
                           })}
                           handleAddition={(e:Tag) => this.handleAddition(e)}
                           delimiters={delimiters}
                           allowDragDrop={false}
                           minQueryLength={0}
                           allowDeleteFromEmptyInput={false}
                           autofocus={false}/>
                    
                    <ConfirmModal
                        show={this.state.showIdleForm}
                        heading="Are sure you want to Delete?"
                        description={`You are about to Delete the tag: `+ this.state.textTag }
                        okLabel="OK"
                        onOk={()=>
                            this.handleDelete(this.state.numberTag!)    
                        }
                        onCancel={()=>this.setState({
                            showIdleForm: false
                        }) }
                    />

            </div>
        )
    }

}


//Search user attributes cant find labels, because they are currently stored as a text array. either create a new attribute for each label or change how we search attributes.
//Pros for creating a new attribute for every label are: editing labels will be easier and searching for them. cons; attributes list can get messy.
//Pros for keeping them in one attribute: clean attribute list. Cons: Search need to be reworked and editing a string array can be tricky but not impossible.


export default UserLabelsComponent;
